<script>
import { mapActions, mapGetters } from 'vuex'
import { PermissionScope } from '@/shared/constants/permissions/PermissionScope'
import routeDefinitions from '@/shared/constants/routes/routeDefinitions'
import { PermissionModifier } from '@/shared/constants/permissions/PermissionModifier'

export default {
  name: 'OutstandingInvoiceAlert',
  data: () => {
    return {
      outstandingInvoicesCount: 0,
      displayAlert: false,
    }
  },
  computed: {
    ...mapGetters({
      hasPermissionRegardlessOfLevel: 'auth/hasPermissionRegardlessOfLevel',
    }),
    hasFinanceAccess() {
      return this.hasPermissionRegardlessOfLevel(
        PermissionScope.ACCOUNTS,
        PermissionModifier.VIEW
      )
    },
  },
  async created() {
    // Don't load invoice data if user doesn't have finance access
    if (!this.hasFinanceAccess) return

    // Only display alert if on pages other than those listed here
    const pagesToAvoidShowingAlert = [
      routeDefinitions.finance.name,
      routeDefinitions.invoiceDetails.name,
      routeDefinitions.help.name,
      routeDefinitions.clientOverview.name,
      routeDefinitions.clientGroupOverview.name,
    ]

    if (!pagesToAvoidShowingAlert.includes(this.$route.matched[0].name)) {
      this.displayAlert = true

      const invoiceCountResult = await this.getOustandingInvoicesCount()
      if (invoiceCountResult.data !== null) {
        this.outstandingInvoicesCount = invoiceCountResult.data
      }
    }
  },
  methods: {
    ...mapActions({
      getOustandingInvoicesCount: 'invoices/getOustandingInvoicesCount',
    }),
  },
}
</script>

<template v-if="hasFinanceAccess">
  <v-alert
    v-if="displayAlert"
    prominent
    text
    type="warning"
    class="mb-8"
    :value="outstandingInvoicesCount > 0"
  >
    <v-row align="center">
      <v-col class="grow subtitle-2">
        {{
          $t('finance.invoiceOutstandingCountAlertText', {
            invoiceCount: $tc(
              'finance.invoiceOutstandingCountNumber',
              outstandingInvoicesCount,
              { count: outstandingInvoicesCount }
            ),
          })
        }}
      </v-col>
      <v-col class="shrink">
        <v-btn color="warning" text outlined to="/finance" depressed>
          View Invoices
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<style lang="scss" module>
@import '@styles';
</style>
